export class InventoryRequestModel {
    region: string;
    userId: string;
    wh: string;
    whLocation: string;
    pageNo: string;
    product: string;
}
export class InventoryResponseModel {
    whCode: string;
    whlocation: string;
    productId:string;
    productName:string;
    expDate:string;
    stockAvailable: string;
}